export const MESSAGES = {
  DEFAULT_LOGIN_ERROR_MESSAGE:
    "An unexpected error occurred while trying to log in",
  ACCESS_TO_COMPASS: "Access to Compass",
  NO_FILTER_APPLIED: "(Default)",
  LOADING_FILTERS: "Loading filters...",
  PARIS_ALIGNED: {
    SUCCESS: "The fund is aligned with the objectives of the Paris Agreement.",
    FAILURE: "The fund is NOT Paris-aligned. Please review your investments.",
  },
  DEFAULT_GET_CONTROL_PANEL_DATA_ERROR_MESSAGE:
    "An error occurred while trying to retrieve control panel data",
  GET_CONTROL_PANEL_DATA_SUCCESS: "Control panel data retrieved successfully",
  FILE_UPLOAD: {
    UPLOAD_FILE_SUCCESS: "File uploaded successfully",
    UPLOAD_FILE_ERROR: "An error occurred while trying to upload the file",
    ADD_FILE_TITLE_DESCRIPTION:
      "Populate your workspace by uploading files here. Choose between a portfolio, voting records, or a engagement records. ",
    ADD_FILE_MAIN:
      "Please upload your file file here. Accepted file types are .csv and .xlsx",
  },

  CALCULATE_METRICS_TITLE: {
    CALCULATING: "Calculating",
    NOT_CALCULATING: "Calculate your metrics",
  },
  CALCULATE_METRICS_DESCRIPTION: {
    CALCULATING:
      "We are merging your portfolio with up-to-date market data and your chosen provider's ESG metrics. This may take a few minutes.",
    NOT_CALCULATING:
      "Click On Go in order to calculate all the metrics from your uploaded portfolio and have them appear in analytics",
  },
  PROCESS_ENGAGEMENT_RECORDS_TITLE: {
    PROCESSING: "Processing",
    NOT_PROCESSING: "Process your engagement records",
  },
  PROCESS_VOTING_RECORDS_TITLE: {
    PROCESSING: "Processing",
    NOT_PROCESSING: "Process your voting records",
  },
  PROCESS_ENGAGEMENT_RECORDS_DESCRIPTION: {
    PROCESSING:
      "We are processing your engagement records. This may take a few minutes.",
    NOT_PROCESSING:
      "Click On Go in order to process your engagement records and have them appear in stewardship and company profiles",
  },
  PROCESS_VOTING_RECORDS_DESCRIPTION: {
    PROCESSING:
      "We are processing your voting records. This may take a few minutes.",
    NOT_PROCESSING:
      "Click On Go in order to process your voting records and have them appear in stewardship and company profiles",
  },

  GENERATE_REPORT_TITLE: {
    GENERATING: "Generating",
    NOT_GENERATING: "Generate a report",
  },
  REPORTS_LIST_DESCRIPTION:
    " Generate reports to inform the development of your decarbonisation strategies, internal risk management, and support client facing and regulatory disclosures.",
  MY_PORTFOLIOS_DESCRIPTION:
    "View and manage your uploaded portfolios. Choose a benchmark to compare your portfolio level metrics against. ",
  CONTROL_PANEL_DESCRIPTION:
    "View and manage your uploaded portfolios at a glance",
  GENERATE_REPORT_DESCRIPTION: {
    TCFD: {
      GENERATING: "We are generating your report. This may take a few minutes.",
      NOT_GENERATING:
        "Generate a report for the Task Force on Climate-related Financial Disclosures, which provides a framework for companies to disclose climate-related risks and opportunities.",
    },
    STEWARDSHIP: {
      GENERATING: "We are generating your report. This may take a few minutes.",
      NOT_GENERATING:
        "Generate a report for your voting activities compared against your chosen benchmark.",
    },
    STEWARDSHIP_CODE: {
      GENERATING: "We are generating your report. This may take a few minutes.",
      NOT_GENERATING:
        "Generate a stewardship code report for your selected benchmark.",
    },
    ENGAGEMENT: {
      GENERATING: "We are generating your report. This may take a few minutes.",
      NOT_GENERATING:
        "Generate an engagement report for your selected manager.",
    },
  },
  GET_FUND_NAMES_ERROR: "An error occurred while trying to retrieve fund names",
  GET_MY_FUNDS_METRICS_ERROR:
    "An error occurred while trying to retrieve metrics",
  GET_FUND_NAMES_SUCCESS: "Fund names retrieved successfully",
  GET_FUND_METRICS_SUCCESS: "Fund metrics retrieved successfully",
  DEFAULT_CREATE_REPORT_ERROR_MESSAGE:
    "An error occurred while trying to create the report",
  CREATE_REPORT_JOB_TRIGGERED: "Report Creation Request successfully submitted",
  CREATE_REPORT_SUCCESS: "Report created successfully",
  ALL_PARAMS_NOT_SELECTED: "Please select all parameters",
  NOT_AVAILABLE: "-",
  NOT_AVAILABLE_TEXT: "N/A",
  SCREENING_TOOL: {
    DESCRIPTION:
      "The screening tool allows you to screen the holdings in your portfolio against a range of climate-related metrics. You can use this tool to identify climate-related risks and flag non-compliant investments.",
    GET_COMPANY_METRICS_ERROR:
      "An error occurred while trying to retrieve company metrics",
    COMPANY_PROFILE:
      "The company profile page provides an overview of the company's ESG metrics, engagements and stewardship. You can use this page to understand where a company is held in your portfolio and to assess its climate-related risks.",
    ERROR_FETCHING_COMPANY_EXPOSURE:
      "An error occurred while trying to fetch company exposure",
    ERROR_FETCHING_VOTING_ALIGNMENT:
      "An error occurred while trying to fetch voting alignment records",
    ERROR_FETCHING_COMPANY_SUMMARY:
      "An error occurred while trying to fetch company summary",
    ERROR_FETCHING_ENGAGEMENT_RECORDS:
      "An error occurred while trying to fetch engagement records",
    ERROR_FETCHING_PUBLIC_METRICS:
      "An error occurred while trying to fetch public metrics",
  },
  COMPANY_PROFILE: {
    NZA: {
      CA100: {
        LOBBYING_TITLE: "Climate Action 100+ Lobbying",
        LOBBYING_DESCRIPTION:
          "Alignment Assessments complement the Disclosure Framework. They provide independent evaluations of the alignment and adequacy of company actions with the goals of Climate Action 100+ and the Paris Agreement. Refer to the InfluenceMap website for the most recent company assessments.",
        DISCLOSURE_TITLE: "Climate Action 100+ Disclosure",
        DISCLOSURE_DESCRIPTION:
          "The Disclosure Framework evaluates the adequacy of corporate disclosure in relation to key actions companies can take to align their businesses with the Climate Action 100+ and Paris Agreement goals. The assessments are conducted by the Transition Pathway Initiative Global Climate Transition Centre.",
      },
      NA100: {
        TITLE: "Nature Action 100 Initiative",
        DESCRIPTION:
          "Nature Action 100 is a global investor-led engagement initiative that aims to support greater corporate ambition and action on reversing nature and biodiversity loss to mitigate financial risk and to protect the long-term economic interests of investors' clients and beneficiaries.",
      },
    },
  },
  ALIGNMENT_COMMITMENT: {
    COMMITTED: "Committed to Aligning",
    NOT_COMMITTED: "Not Committed to Aligning",
    NOT_AVAILABLE: "Not Available",
  },
  STEWARDSHIP: {
    MATERIALITY: {
      SELECTED_CLUSTER_TITLE: "Selected Cluster",
      SELECTED_CLUSTER_DESCRIPTION:
        "The following companies have been clustered together because they share similar characteristics in weight and engagement materiality.",
    },
    VOTING: {
      VOTING_MODAL_DESCRIPTION:
        "Review how investment managers voted and compare their decisions to your policy and management’s recommendations to assess alignment towards your stewardship practices.",
    },
    ENGAGEMENT_MODULE: {
      DESCRIPTION:
        "The engagement module allows you to view and manage your engagement activities for a specific companies. You can raise escalations, view engagement history and track progress.",
      ESCALATION_MESSAGES: {
        E1: {
          E1_1: "Set clear and time-bound expectations on material responsible investment issues",
          E1_2: "Regular calls and meetings with the company",
          E1_3: "Unilateral calls and meetings with the company",
          E1_4: "Unilateral letter to the senior management or the board",
        },
        E2: {
          E2_1: "Collaborative meetings with the senior management or the board",
          E2_2: "Collaborative private letters to the senior management or the board",
          E2_3: "Challenge management on earnings calls, corporate events or roadshows",
          E2_4: "Unilateral public statement to management and / or the board",
          E2_5: "Collaborative public statements / letters to senior management or the board",
          E2_6: "Be cited in the media challenging the company's position",
        },
        E3: {
          E3_1: "Vote against standing items incl. director (re)election, audited accounts, mangement compensation",
          E3_2: "Vote for shareholder resolutions on ESG topics, against management recommendation",
          E3_3: "Ask questions or making statements of intent at AGM",
          E3_4: "Pre-disclose voting intentions (private / public)",
          E3_5: "Co-file shareholder resolutions",
          E3_6: "Seek a board seat",
          E3_7: "Call an EGM",
          E3_8: "Take legal action",
        },
        E4: {
          E4_1: "Divest / exclude from labelled funds",
          E4_2: "Reduce exposure / underweight in all funds",
          E4_3: "Engage with index provider to exclude company at next rebalancing",
        },
        E5: {
          E5_1: "Divest privately",
          E5_2: "Divest publicly",
        },
      },
      // Short escalation descriptions for compact display (tooltips, badges, etc.)
      ESCALATION_SHORT: {
        E1_1: "Set clear expectations",
        E1_2: "Regular calls and meetings",
        E1_3: "Unilateral calls",
        E1_4: "Unilateral letter",
        E2_1: "Collaborative meetings",
        E2_2: "Collaborative letters",
        E2_3: "Challenge on earnings calls",
        E2_4: "Public statement",
        E2_5: "Collaborative public statements",
        E2_6: "Media citation",
        E3_1: "Vote against standing items",
        E3_2: "Vote for ESG resolutions",
        E3_3: "AGM statements",
        E3_4: "Pre-disclose voting",
        E3_5: "Co-file resolutions",
        E3_6: "Seek board seat",
        E3_7: "Call EGM",
        E3_8: "Legal action",
        E4_1: "Divest from labelled funds",
        E4_2: "Reduce exposure",
        E4_3: "Engage with index provider",
        E5_1: "Divest privately",
        E5_2: "Divest publicly",
      },
      // UN Sustainable Development Goals
      SDG_NAMES: {
        1: "No Poverty",
        2: "Zero Hunger",
        3: "Good Health and Well-being",
        4: "Quality Education",
        5: "Gender Equality",
        6: "Clean Water and Sanitation",
        7: "Affordable and Clean Energy",
        8: "Decent Work and Economic Growth",
        9: "Industry, Innovation and Infrastructure",
        10: "Reduced Inequalities",
        11: "Sustainable Cities and Communities",
        12: "Responsible Consumption and Production",
        13: "Climate Action",
        14: "Life Below Water",
        15: "Life on Land",
        16: "Peace, Justice and Strong Institutions",
        17: "Partnerships for the Goals",
      },
      ENGAGEMENT_SUBTHEME_METRICS: {
        UPDATE_SUCCESS: "Successfully updated engagement sub-theme metric",
        UPDATE_ERROR: "Unable to update sub-theme property",
      },
      ENGAGEMENT_RECORD: {
        CREATE_SUCCESS: "Successfully created engagement record",
        UPDATE_SUCCESS: "Successfully updated engagement record",
        CREATE_ERROR: "Unable to create engagement record",
        UPDATE_ERROR: "Unable to update engagement record",
        UPSERT_ERROR: "An error occurred while saving the engagement record",
        VALIDATION_ERROR: "Please check the form for validation errors",
      },
      ENGAGEMENT_UPDATE: {
        CREATE_SUCCESS: "Successfully added engagement update",
        CREATE_ERROR: "Failed to add engagement update. Please try again.",
      },
      ENGAGEMENT_LINKAGE: {
        INTERACTION_CLASS: {
          CONSISTENT_REINFORCEMENT:
            "Same manager. The vote directly and logically supports their prior engagement goals",
          INTERNAL_INCONSISTENCY:
            "Same manager. The vote contradicts their prior engagement goal",
          SYNERGISTIC_ALIGNMENT:
            "Different managers. Actions align; the vote reinforces the engagement, amplifying the Asset Owner's overall voice",
          ACTIVE_UNDERMINING:
            "Different managers. The vote by one manager actively conflicts with the documented goal of another manager's engagement",
        },
        LINKAGE_TYPE: {
          THEMATIC_ALIGNMENT:
            "Actions share a common goal but are separated by time or focus; no explicit causal threat was made",
          COMPLEMENTARY_ACTION:
            "Two distinct actions (same or different parties) reinforce the same objective without direct escalation",
          ESCALATION_PATH:
            "The vote is the sanction threatened or implied during prior engagement. Clear cause-and-effect",
          ISOLATED_ACTIVITY:
            "Records are linked by company/topic but show minimal strategic coordination",
        },
        SEQUENCE_FLOW: {
          ENGAGEMENT_PRECEDES_VOTE:
            "The engagement was proactive; it set the context and drove the subsequent voting decision",
          VOTE_PRECEDES_ENGAGEMENT:
            "The engagement was reactive; initiated after a surprising or controversial vote to seek clarification",
          BIDIRECTIONAL:
            "Records are close in time (within ~30 days) and show simultaneous action or continuous dialogue",
        },
      },
    },
  },
  JOB_PARAMS: {
    FETCHING_PARAMS_ERROR:
      "An error occurred while trying to fetch job parameters",
  },
  NEWS_FEED: {
    TITLE: "Latest news",
    SEGMENT_LABEL: "News",
    WINDOW: "Last 30 days",
    EXPAND: "Expand news timeline",
    COLLAPSE: "Collapse news timeline",
    EMPTY: "No company news in the last 30 days",
    EMPTY_RANGE: "No company news in this period",
    ALL: "All",
    NOTHING_NEW: (period: string): string => `No new stories found ${period}`,
    STORIES_ADDED: (count: number, period: string): string =>
      `${count} new ${count === 1 ? "story" : "stories"} added ${period}`,
    RECENT_SEARCHES: "Recent searches",
    SEARCHED: (when: string): string => `Searched ${when}`,
    NOTHING_NEW_SHORT: "nothing new",
    NEW_COUNT: (count: number): string => `${count} new`,
    SEARCHED_EMPTY: (when: string): string =>
      `Searched ${when} — no news found in this period`,
    LATEST_NEWS: "Latest news",
    ERROR: "Couldn't load company news",
    GENERATE: "Generate news for top 50 holdings",
    GENERATE_SHORT: "Generate news",
    REFRESH: "Refresh news for top 50 holdings",
    GENERATE_COMPANY: "Generate news for this company",
    REFRESH_COMPANY: "Refresh news for this company",
    PREPARING: "Preparing news",
    JOB_NAME: "Company News",
    PREPARE_FAILED: "Couldn't prepare company news",
  },
  ACTION_TRACKER: {
    TITLE: "Action tracker",
    WORKSPACE_LINK: "Workspace →",
    EMPTY: "No open actions",
    OPEN: "open",
    IN_PROGRESS: "in progress",
    DONE: "done",
    GENERAL_TASK: "General task",
    DUE: "Due",
    OVERDUE: "Overdue",
  },
  JOB_RUN: {
    SUCCESS: "Job ran successfully",
    ERROR: "An error occurred while trying to run the job",
  },
  STEWARDSHIP_HOMEPAGE: {
    DESCRIPTION:
      "Welcome to the stewardship page. Here you can view and manage your stewardship activities, including voting records and engagements.",
    ENGAGEMENTS_DESCRIPTION:
      "Browse engagement records and analyse activity, materiality, and assessment across your stewardship programme.",
    VOTING_DESCRIPTION:
      "Review voting activity as a core stewardship mechanism, independently of engagement linkage.",
    LINKAGE_DESCRIPTION:
      "Explore the relationships between engagement activities and voting behaviour across themes, material topics, and managers.",
    FETCH_OPTIONS_ERROR: (optionItem: string): string =>
      `An error occurred while trying to fetch ${optionItem}`,
  },
  WORKSPACE: {
    DESCRIPTION:
      "Welcome to your workspace. Here you can create and view tasks, engage with your team, and track your progress. flagged items will appear here.",
    ADD_NOTE: "Add a note...",
    NOTE_MODAL: {
      ADD_NOTE_DESCRIPTION: "Add relevant destails related to your task",
      VIEW_NOTE_DESCRIPTION: (date: string): string => `Added on ${date}`,
    },
  },
  MAGIC_LINK: {
    SUCCESS: "Successfully authenticated via magic link",
    ERROR: {
      INVALID_TOKEN: "Invalid or expired magic link token",
      MISSING_TOKEN: "No magic link token provided",
      VALIDATION_FAILED:
        "Magic link validation failed. Please request a new link.",
      CONTEXT_RETRIEVAL_FAILED:
        "Failed to retrieve user context. Please try again.",
      GENERIC: "An error occurred during magic link authentication",
    },
    ACCESS_RESTRICTED: "Your account only has access to file uploads",
    CREATE_SUCCESS: "Magic link created successfully",
    CREATE_ERROR: "Failed to create magic link",
    COPIED: "Magic link copied to clipboard",
    SHARE_INSTRUCTIONS:
      "Magic link created successfully. Share this link with the manager:",
    COPY_LINK: "Copy Link",
    CREATE_ANOTHER: "Create Another",
    CREATE_BUTTON: "Create Magic Link",
    FORM: {
      EMAIL_LABEL: "Email",
      EMAIL_PLACEHOLDER: "Enter email address",
      EMAIL_REQUIRED: "Please enter an email",
      EMAIL_INVALID: "Please enter a valid email",
      EMAIL_HELPER: "An email with a magic link will be sent to this address",
      MANAGER_LABEL: "Manager",
      MANAGER_PLACEHOLDER: "Select a manager",
      MANAGER_REQUIRED: "Please select a manager",
      MANAGER_HELPER:
        "This person will be able to upload data for this manager",
    },
    DESCRIPTION: {
      TITLE: "Invite via Magic Link",
      TEXT: "Generate a secure, one-time link to invite external users to upload files. The recipient will receive access without needing to create an account. Links expire after 72 hours for security.",
    },
    CONFIRM: {
      TITLE: "Send Magic Link?",
      CONTENT: (email: string, manager: string): string =>
        `This will send an email to ${email} with a link granting them access to upload data for ${manager}. Are you sure you want to proceed?`,
      OK: "Yes, send it",
      CANCEL: "Cancel",
    },
  },
  FILE_DROP: {
    SINGLE_FILE_ONLY: "Please drop only one file at a time",
    CLICK_TO_UPLOAD: "Click to upload",
    DRAG_AND_DROP: "or drag and drop your",
    HERE: "here",
    FILE_TYPES: "Excel or CSV (Max. 2.5MB)",
  },
  COMPASS_AI: {
    PAGE_TITLE: "Compass AI",
    PAGE_DESCRIPTION:
      "Leverage AI-powered tools to automate data extraction and analysis. Select a feature below to get started.",
    PDF_EXTRACTION: {
      TITLE: {
        IDLE: "Upload PDF Document",
        UPLOADING: "Uploading",
        UPLOADED: "Ready to Extract",
        EXTRACTING: "Extracting Data",
        POLLING: "Processing",
        SUCCESS: "Extraction Complete",
        ERROR: "Extraction Failed",
      },
      DESCRIPTION: {
        IDLE: "Upload a PDF to extract structured engagement records with AI.",
        UPLOADING: "Uploading your document to secure storage...",
        UPLOADED: "Your document is ready. Click Extract to begin AI analysis.",
        EXTRACTING:
          "AI is analyzing your document. This may take 30-60 seconds for large PDFs.",
        POLLING:
          "AI is processing your document. You can track the progress below.",
        SUCCESS: "Successfully extracted engagement data from your PDF.",
        ERROR: "An error occurred during extraction. Please try again.",
      },
      MODAL_TITLE: "PDF Extraction",
      UPLOAD_BUTTON: "Upload PDF",
      EXTRACT_BUTTON: "Extract",
      DOWNLOAD_ENGAGEMENTS: "Download Engagements CSV",
      DOWNLOAD_UPDATES: "Download Updates CSV",
      FILE_TYPES: "PDF (Max. 25MB)",
      INVALID_FILE_TYPE: "Please upload a PDF file",
      FILE_TOO_LARGE: "File size must be under 25MB",
    },
    LINKAGE_ANALYSIS: {
      TITLE: {
        IDLE: "Analyze Voting-Engagement Linkages",
        ANALYZING: "Analyzing Linkages",
        SUCCESS: "Analysis Complete",
        ERROR: "Analysis Failed",
      },
      DESCRIPTION: {
        IDLE: "Analyze AI-powered linkages between voting and engagement.",
        ANALYZING:
          "AI is analyzing voting and engagement patterns. This may take a moment.",
        SUCCESS:
          "Successfully identified linkages between voting and engagement records.",
        ERROR: "An error occurred during analysis. Please try again.",
      },
      MODAL_TITLE: "Linkage Analysis",
      ANALYZE_BUTTON: "Analyze",
      SELECT_COMPANY: "Select Company",
      NO_LINKAGES_FOUND: "No linkages found for this company.",
    },
    BATCH_LINKAGE: {
      TITLE: {
        IDLE: "Batch Linkage Analysis",
        ANALYZING: "Analyzing Linkages",
        POLLING: "Processing",
        SUCCESS: "Analysis Complete",
        ERROR: "Analysis Failed",
      },
      DESCRIPTION: {
        IDLE: "Automatically identify and classify relationships between your voting records and engagement activities across all companies. The AI analyzes thematic alignment, escalation paths, and cross-manager coordination to surface meaningful connections.",
        ANALYZING:
          "AI is analyzing voting and engagement patterns across companies. This may take several minutes for large datasets.",
        POLLING: "AI is analyzing your data. You can track the progress below.",
        SUCCESS: "Successfully completed batch analysis across all companies.",
        ERROR: "An error occurred during batch analysis. Please try again.",
      },
      MODAL_TITLE: "Batch Linkage Analysis",
      START_ANALYSIS: "Start Analysis",
      DOWNLOAD_RESULTS: "Download Results",
      SUMMARY: {
        COMPANIES_PROCESSED: "Companies Processed",
        SUCCESSFUL: "Successful",
        FAILED: "Failed",
        TOTAL_LINKAGES: "Total Linkages Found",
        PROCESSING_BATCHES: "Processing Batches",
        HIGH_CONFIDENCE: "High Confidence",
        AVG_CONFIDENCE: "Avg. Confidence",
      },
    },
    ENGAGEMENT_PREFILL: {
      TITLE: {
        IDLE: "Smart Fill Form",
        UPLOADING: "Uploading",
        UPLOADED: "Ready to Extract",
        EXTRACTING: "Extracting Data",
        SUCCESS: "Fields Extracted",
        ERROR: "Extraction Failed",
      },
      DESCRIPTION: {
        IDLE: "Upload documents or paste text to automatically extract engagement details using AI.",
        UPLOADING: "Uploading your document...",
        FILLING: "Extracting relevant data",
        UPLOADED: "Documents ready. Click Extract to begin AI analysis.",
        EXTRACTING: "AI is analyzing your content. This may take a moment.",
        SUCCESS: "Successfully extracted engagement fields.",
        ERROR: "An error occurred during extraction. Please try again.",
      },
      MODAL_TITLE: "Smart Fill Engagement",
      EXTRACT_BUTTON: "Extract Fields",
      FILE_TYPES: "PDF, DOCX, XLSX, CSV, TXT (Max. 25MB each)",
      TEXT_PLACEHOLDER:
        "Paste engagement details, meeting notes, or any relevant text here...",
      MAX_FILES: "Maximum 5 files",
      MAX_TEXT_LENGTH: "Maximum 50,000 characters",
      COMPANY_MISMATCH_WARNING:
        "The uploaded files don't appear to be about the selected company.",
      FILES_IRRELEVANT_WARNING:
        "Some files were not relevant and were skipped.",
      NO_FIELDS_EXTRACTED:
        "No fields could be extracted from the provided content.",
    },
    INTERACTION_PREFILL: {
      TITLE: {
        IDLE: "Smart Fill Form",
        UPLOADING: "Uploading",
        UPLOADED: "Ready to Extract",
        EXTRACTING: "Extracting Data",
        SUCCESS: "Fields Extracted",
        ERROR: "Extraction Failed",
      },
      DESCRIPTION: {
        IDLE: "Upload documents or paste text to automatically extract interaction details using AI.",
        UPLOADING: "Uploading your document...",
        FILLING: "Extracting relevant data",
        UPLOADED: "Documents ready. Click Extract to begin AI analysis.",
        EXTRACTING: "AI is analyzing your content. This may take a moment.",
        SUCCESS: "Successfully extracted interaction fields.",
        ERROR: "An error occurred during extraction. Please try again.",
      },
      MODAL_TITLE: "Smart Fill Interaction",
      EXTRACT_BUTTON: "Extract Fields",
      FILE_TYPES: "PDF, DOCX, XLSX, CSV, TXT (Max. 25MB each)",
      TEXT_PLACEHOLDER:
        "Paste meeting notes, interaction details, or any relevant text here...",
      MAX_FILES: "Maximum 5 files",
      MAX_TEXT_LENGTH: "Maximum 50,000 characters",
      COMPANY_MISMATCH_WARNING:
        "The uploaded files don't appear to be related to this engagement's company.",
      FILES_IRRELEVANT_WARNING:
        "Some files were not relevant and were skipped.",
      NO_FIELDS_EXTRACTED:
        "No fields could be extracted from the provided content.",
    },
    ENGAGEMENT_ASSESSMENT: {
      TITLE: {
        IDLE: "Assess Engagement Quality",
        ANALYZING: "Running Assessment",
        POLLING: "Processing",
        SUCCESS: "Assessment Complete",
        ERROR: "Assessment Failed",
      },
      DESCRIPTION: {
        IDLE: "Run the AI-powered engagement quality assessment pipeline across your engagement records. The assessment evaluates intent, six quality pillars, and seven engagement sins.",
        ANALYZING:
          "AI is assessing your engagement records. This may take several minutes for large batches.",
        POLLING:
          "AI is processing your engagements. You can track the progress below.",
        SUCCESS: "Successfully completed engagement quality assessment.",
        ERROR: "An error occurred during assessment. Please try again.",
      },
      MODAL_TITLE: "Engagement Assessment",
      START_ASSESSMENT: "Start Assessment",
      SUMMARY: {
        TOTAL_ASSESSED: "Total Assessed",
        SUCCESSFUL: "Successful",
        FAILED: "Failed",
        GENUINE: "Genuine Intent",
        UNCLEAR: "Unclear Intent",
        HIDDEN: "Hidden Intent",
        SINS_DETECTED: "Sins Detected",
        COMPANIES: "Companies",
      },
    },
    ERRORS: {
      UPLOAD_FAILED: "Failed to upload file. Please try again.",
      EXTRACTION_FAILED: "AI extraction failed. Please try again.",
      ANALYSIS_FAILED: "Linkage analysis failed. Please try again.",
      ASSESSMENT_FAILED: "Engagement assessment failed. Please try again.",
      DOWNLOAD_FAILED: "Failed to download file. Please try again.",
    },
    SUMMARY: {
      EXTRACTION_SUCCESS: "Engagement data has been extracted successfully.",
      EXTRACTION_RESULTS: "Extraction Results",
      FILE_UPLOADED_PREFIX: "Your file",
      FILE_UPLOADED_SUFFIX: "has been uploaded successfully.",
      PAGES_ANALYZED: "Pages Analyzed",
      RELEVANT_PAGES: "Relevant Pages",
      ENGAGEMENTS_EXTRACTED: "Engagements Extracted",
      UPDATES_EXTRACTED: "Updates Extracted",
      COMPANIES_WITH_ISINS: "Companies with ISINs",
      COMPANIES_WITHOUT_ISINS: "Companies without ISINs",
      THEMES_DISTRIBUTION: "Themes Distribution",
      MILESTONES_DISTRIBUTION: "Milestones Distribution",
      PROCESSING_TIME: "Processing Time",
      TOTAL_LINKAGES: "Total Linkages Found",
      CONFIDENCE_SCORE: "Confidence Score",
    },
  },
  ENGAGEMENT_ASSESSMENT_V2: {
    ERRORS: {
      SINGLE_TRIGGER_FAILED:
        "Failed to start the engagement assessment. Please try again.",
      BATCH_TRIGGER_FAILED:
        "Failed to start the batch engagement assessment. Please try again.",
      HISTORY_FETCH_FAILED:
        "An error occurred while retrieving the engagement assessment history.",
      POLL_FAILED: "The engagement assessment job failed. Please try again.",
      POLL_TIMEOUT:
        "The engagement assessment is taking longer than expected. Please try again later.",
      BATCH_PARTIAL_FAILURE: (failedCount: number): string =>
        `Batch assessment completed with ${failedCount} failed item${
          failedCount === 1 ? "" : "s"
        }.`,
    },
  },
};
